import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import { PrismButtonComponent, PrismDialogComponent, PrismCheckboxComponent } from '@shure/prism-angular-components';

import { AboutDialogComponent } from './about-dialog.component';

@NgModule({
	imports: [CommonModule, PrismDialogComponent, PrismCheckboxComponent, PrismButtonComponent, TranslocoModule],
	declarations: [AboutDialogComponent],
	exports: [AboutDialogComponent]
})
export class ShAboutDialogModule {}
